module.exports = __webpack_public_path__ + "img/PD1506159648875610112.5ebea62b.png";